import React, { useState } from "react";
import "./SoftwareDevelopmentPage.css";
import BannerImage from "../../../assets/other_image/sofware_develoment.jpg";
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../SolutionBanner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import BookDemoSection from "../PolarianALMSolution/BookDemoSection";
import { NavLink } from "react-router-dom";
import SoftwareDevelopmentOverview from "./SoftwareDevelopmentOverview";
import { Helmet } from "react-helmet-async";

const faqData = [
  {
    question: "What is custom software development?",
    answer:
      "Custom software development is the process of designing and building applications tailored to specific business needs, ensuring flexibility, scalability, and competitive advantage.",
  },
  {
    question: "Can NexTech integrate new software with our existing systems?",
    answer:
      "Yes. We specialize in ERP, CRM, legacy tools, and CAD/PDM integrations through custom-built connectors.",
  },
  {
    question: "Does NexTech support cloud-based deployment?",
    answer:
      "Absolutely. We offer cloud-native architecture with high availability, scalability, and security for enterprise deployments.",
  },
  {
    question: "How does NexTech ensure faster time-to-market?",
    answer:
      "By combining Agile methodologies, DevOps practices, and automation tools, we accelerate development cycles while maintaining quality.",
  },
  {
    question: "Can NexTech automate industrial processes?",
    answer:
      "Yes. Our solutions include assembly line balancing, design automation, and workflow optimization to reduce manual effort and improve efficiency.",
  },
  {
    question: "What industries does NexTech serve?",
    answer:
      "We serve diverse industries including manufacturing, automotive, healthcare, retail, and enterprise IT with tailored solutions.",
  },
  {
    question: "Does NexTech provide ongoing support?",
    answer:
      "Yes. Our managed support services include 24/7 monitoring, updates, and scalability enhancements for long-term success.",
  },
];

const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="faq-item">
      <button
        className="faq-question"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span>{question}</span>
        <span>{open ? "−" : "+"}</span>
      </button>
      {open && <div className="faq-answer">{answer}</div>}
    </div>
  );
};

const SectionHeader = ({ title, subtitle }) => (
  <header className="section-header">
    <h2 className="section-title">{title}</h2>
    {subtitle && <p className="section-subtitle">{subtitle}</p>}
  </header>
);

const TileGrid = ({ items }) => (
  <div className="tile-grid-3x2">
    {items.map((item, index) => (
      <article className="feature-tile" key={index}>
        {item.icon && (
          <div className="tile-icon">
            <img src={item.icon} alt={item.title} width="48" height="48" />
          </div>
        )}
        <h3 className="tile-title">{item.title}</h3>
        <p className="tile-content">{item.content}</p>
      </article>
    ))}
  </div>
);

const SoftwareDevelopmentPage = () => {
  const featuredSolutionsItems = [
    {
      title: "Custom Application Development",
      content:
        "Tailor-made solutions designed to meet unique business challenges with speed, security, and scalability.",
    },
    {
      title: "Software Connectors & Integration",
      content:
        "Enable smooth data migration, legacy tool integration, and real-time data transfer between critical enterprise systems.",
    },
    {
      title: "Agile & DevOps Enablement",
      content:
        "Implement CI/CD, automated testing, and iterative delivery for consistent quality and faster time-to-market.",
    },
    {
      title: "Cloud-Native Software Solutions",
      content:
        "Deploy applications across cloud environments with built-in high availability, scalability, and security.",
    },
    {
      title: "Business–IT Collaboration Tools",
      content:
        "Bridge the gap between business users and IT teams with collaborative tools, ensuring projects stay aligned with business goals.",
    },
    {
      title: "Process Automation & Optimization",
      content:
        "Automate complex workflows like assembly line balancing and design automation to boost efficiency and reduce costs.",
    },
  ];

  const ourSolutionsItems = [
    {
      icon: "https://img.icons8.com/fluency/48/laptop-coding.png",
      title: "Complete Software Development",
      content:
        "End-to-end development customized for your business needs with faster delivery and reduced costs.",
    },
    {
      icon: "https://img.icons8.com/fluency/48/link.png",
      title: "Enterprise System Integration",
      content:
        "Connect software seamlessly with ERP, CRM, PDM, and legacy systems.",
    },
    {
      icon: "https://img.icons8.com/fluency/48/design.png",
      title: "Custom UI & Workflow Design",
      content:
        "Create intuitive user experiences and optimized workflows that reflect your brand identity.",
    },
    {
      icon: "https://img.icons8.com/fluency/48/training.png",
      title: "Role-Based Training",
      content:
        "Empower teams with role-specific training to manage and enhance applications independently.",
    },
    {
      icon: "https://img.icons8.com/fluency/48/process.png",
      title: "Process Optimization",
      content:
        "Align software initiatives with KPIs and business goals for continuous improvement.",
    },
    {
      icon: "https://img.icons8.com/fluency/48/restart.png",
      title: "Managed Support & Maintenance",
      content:
        "Ensure long-term success with 24/7 support, updates, and scalability enhancements.",
    },
  ];

  const whyNextechItems = [
  {
    icon: "https://img.icons8.com/fluency/48/task.png", 
    title: "Proven Methodologies & Standards",
    content:
      "Adherence to global standards ensures robust, efficient, and reliable software solutions.",
  },
  {
    icon: "https://img.icons8.com/fluency/48/rocket.png",
    title: "Agile & DevOps Expertise",
    content:
      "Accelerate delivery while maintaining quality and minimizing errors.",
  },
  {
    icon: "https://img.icons8.com/fluency/48/supply-chain.png",
    title: "Unique Delivery Model",
    content:
      "Enhance business performance with predictable, consistent, and timely execution.",
  },
  {
    icon: "https://img.icons8.com/fluency/48/handshake.png",
    title: "Business–IT Alignment",
    content:
      "Drive ROI with active stakeholder engagement and aligned strategies.",
  },
  {
    icon: "https://img.icons8.com/fluency/48/globe-earth.png",
    title: "Cross-Platform Delivery",
    content:
      "Build solutions that seamlessly run across web, desktop, and mobile.",
  },
  {
    icon: "https://img.icons8.com/fluency/48/security-checked.png", // ⭐ FIXED ICON
    title: "Risk Mitigation & Predictability",
    content:
      "Reduce risks through structured processes and strong governance.",
  },
];

  return (
    <>
      {/* ✅ Meta Tags for SEO */}
     <Helmet>
  <title>Teamcenter Software Development Services in Pune | NexTech PLM</title>
  <meta
    name="description"
    content="Customized Teamcenter software development solutions in Pune, India. Nextech PLM provides scalable and efficient PLM applications."
  />
  <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
</Helmet>

    <main className="software-dev-page">
      <Banner image={BannerImage} heading="Software Development Solutions" />
      <FloatingContactUs />
      <SoftwareDevelopmentOverview />

      {/* Benefits Section */}
      <section className="section benefits-section">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 col-12">
              <div className="benefits-card">
                <h3 className="benefits-heading">
                  Business Benefits of Software Development with NexTech
                </h3>
                <ul className="benefits-list">
                  <li>
                    <span className="benefit-icon">✔</span> Accelerate Digital
                    Transformation – Deploy tailored applications faster using
                    Agile and DevOps practices at every stage.
                  </li>
                  <li>
                    <span className="benefit-icon">✔</span> Reduce Human
                    Intervention – Automate repetitive processes to improve
                    efficiency and minimize errors.
                  </li>
                  <li>
                    <span className="benefit-icon">✔</span> Unify Data &
                    Workflows – Integrate systems seamlessly with custom-built
                    connectors for smooth data flow across business functions.
                  </li>
                  <li>
                    <span className="benefit-icon">✔</span> Deploy at Enterprise
                    Scale – Leverage cloud-native architecture for secure,
                    scalable, and resilient deployments.
                  </li>
                  <li>
                    <span className="benefit-icon">✔</span> Enhance User
                    Experience – Deliver intuitive, accessible, and responsive
                    applications with custom UI/UX design.
                  </li>
                  <li>
                    <span className="benefit-icon">✔</span> Ensure Long-Term
                    Value – Build adaptable software solutions that scale with
                    your business needs.
                  </li>
                  <li>
                    <span className="benefit-icon">✔</span> Optimize Costs &
                    Resources – Increase productivity while reducing overall
                    development and maintenance costs.
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-6 col-12 d-flex align-items-center">
              <div className="quick-links">
                <h4>Quick Links</h4>
                <ul>
                  <li>
                    <NavLink to="/services/cloud-development">
                      Cloud Development
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/services/devops-consulting">
                      DevOps Consulting
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/services/system-integration">
                      System Integration
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/services/ui-ux-design">UI/UX Design</NavLink>
                  </li>
                  <li>
                    <NavLink to="/services/enterprise-apps">
                      Enterprise Applications
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/services/automation">
                      Automation Solutions
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/services/support-maintenance">
                      Support & Maintenance
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BookDemoSection />

      <section className="section featured-solutions-section">
        <div className="container">
          <SectionHeader
            title="Featured Software Development Solutions"
            subtitle="Explore the Core Capabilities that Accelerate Innovation, Efficiency, and Growth."
          />
          <TileGrid items={featuredSolutionsItems} />
        </div>
      </section>

      <section className="section our-solutions-section">
        <div className="container">
          <SectionHeader title="Our Software Development Services" />
          <p className="section-intro">
            Transform Software Development into a Strategic Business Advantage
            <br />
            At <strong>NexTech PLM</strong>, we don’t just develop software — we
            turn it into a growth enabler. Our services are designed to reduce
            risk, optimize costs, and deliver measurable business outcomes.
          </p>
          <TileGrid items={ourSolutionsItems} />
        </div>
      </section>

      <section className="section why-nextech-section">
        <div className="container">
          <SectionHeader title="Why Choose NexTech for Custom Software Development?" />
          <p className="section-intro">
            Your Strategic Partner in Software Innovation
          </p>
          <TileGrid items={whyNextechItems} />
        </div>
      </section>

      <section className="section faq-section">
        <div className="container">
          <SectionHeader title="Software Development FAQs" />
          <div className="faq-container">
            {faqData.map((item, i) => (
              <FAQItem key={i} question={item.question} answer={item.answer} />
            ))}
          </div>
        </div>
      </section>

      <Letsgetintouch />
    </main>
</>
  );
};

export default SoftwareDevelopmentPage;
